window.iFrameResizer = {
  targetOrigin: '*'
}
